export default function numberFormat(number) {
  return Intl.NumberFormat().format(number);
}
